class StickyMobileCTA {
  constructor() {
    this.button = document.querySelector('[data-sticky-cta-button]');
    this.textElement = document.querySelector('[data-sticky-cta-text]');
    this.targetSection = document.querySelector('#discover-wake') || document.querySelector('.featured-product-custom');
    this.addToCartButton = document.querySelector('[data-add-to-cart-button]');
    
    if (!this.button || !this.targetSection) {
      console.warn('Sticky CTA: Required elements not found', {
        button: !!this.button,
        targetSection: !!this.targetSection,
        addToCartButton: !!this.addToCartButton
      });
      return;
    }
    
    console.log('Sticky CTA initialized', {
      targetSection: this.targetSection,
      addToCartButton: this.addToCartButton
    });

    this.isInSection = false;
    
    this.init();
  }

  init() {
    this.setupIntersectionObserver();
    this.setupClickHandler();
  }

  setupIntersectionObserver() {
    const options = {
      root: null,
      rootMargin: '0px',
      threshold: [0, 0.1, 0.5, 0.9, 1]
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        const wasInSection = this.isInSection;
        this.isInSection = entry.isIntersecting && entry.intersectionRatio > 0.1;
        
        // Ne mettre à jour que si l'état a changé
        if (wasInSection !== this.isInSection) {
          this.updateButton();
        }
      });
    }, options);

    observer.observe(this.targetSection);
  }

  updateButton() {
    if (this.isInSection) {
      // Slide down (cacher le bouton)
      this.button.classList.add('sticky-mobile-cta__button--hidden');
    } else {
      // Slide up (montrer le bouton)
      this.button.classList.remove('sticky-mobile-cta__button--hidden');
    }
  }

  setupClickHandler() {
    this.button.addEventListener('click', (e) => {
      e.preventDefault();
      // Toujours scroller vers la section
      this.scrollToSection();
    });
  }

  scrollToSection() {
    const headerOffset = 100; // Offset pour le header si nécessaire
    const elementPosition = this.targetSection.getBoundingClientRect().top;
    const offsetPosition = elementPosition + window.pageYOffset - headerOffset;

    window.scrollTo({
      top: offsetPosition,
      behavior: 'smooth'
    });
  }
}

// Initialisation au chargement du DOM
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new StickyMobileCTA();
  });
} else {
  new StickyMobileCTA();
}

